import EADialog from 'components/common/EADialog';
import i18next from 'i18next';
import { Trans } from "react-i18next";
import useStyles from 'style/js-style/components/thirdparties/securityRating/SecurityRatingStyle';

const SecurityRatingCompanyScopeModal = ({ isOpen = false, onClose = () => { } }) => {
  const { classes } = useStyles();

  return (
    <EADialog
      isOpen={isOpen}
      maxWidth="md"
      hasActions={false}
      onClose={onClose}
      title={i18next.t("securityRating.form.companyScopeModal.title")}
    >
      <div className={classes.companyScopeModalContainer}>
        <div>
          <Trans i18nKey={`securityRating.form.companyScopeModal.bloc`}
            components={{ strong: <b></b>, br: <br /> }}
          />
        </div>
        <div>
          <Trans i18nKey={`securityRating.form.companyScopeModal.verificationList`}
            components={{ ul: <ul></ul>, li: <li></li> }}
          />
        </div>
        <div className={classes.companyScopeModalExamples}>
          <div>
            <Trans i18nKey={`securityRating.form.companyScopeModal.example1`}
              components={{ colored: <span className={classes.companyScopeCorrect}></span>, br: <br /> }}
            />
          </div>
          <div>
            <Trans i18nKey={`securityRating.form.companyScopeModal.example2`}
              components={{ colored: <span className={classes.companyScopeIncorrect}></span>, br: <br /> }}
            />
          </div>
        </div>
      </div>

    </EADialog>
  )
};

export default SecurityRatingCompanyScopeModal;